export function markExternalLinks(root: ParentNode = document) {
  // `querySelectorAll` only returns descendants, so an anchor passed in directly
  // (e.g. a bare `<a>` added to the DOM and observed by a MutationObserver) would
  // be skipped. Include the root itself when it is a matching anchor.
  const anchors = [...root.querySelectorAll<HTMLAnchorElement>('a[href]')]
  if (root instanceof HTMLAnchorElement && root.hasAttribute('href')) {
    anchors.unshift(root)
  }

  for (const a of anchors) {
    if (a.classList.contains('external-link')) continue
    if (a.classList.contains('no-external-icon')) continue

    const href = a.getAttribute('href')?.trim()
    if (!href) continue

    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    )
      continue

    let url: URL
    try {
      url = new URL(href, window.location.href)
    } catch {
      continue
    }

    if (url.origin === window.location.origin) continue

    a.classList.add('external-link')
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
  }
}
